import { render, staticRenderFns } from "./AccordionCard.vue?vue&type=template&id=f530b1d6&"
import script from "./AccordionCard.vue?vue&type=script&lang=ts&"
export * from "./AccordionCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports